import moment from 'moment';
var isDateInValidRange = function (amount, units, format) { return function (value) {
    var compareDate = moment(value, format, true);
    var startDate = moment().subtract(amount, units);
    var endDate = moment().add(amount, units);
    return compareDate.isBetween(startDate, endDate);
}; };
export default isDateInValidRange;
